module.exports = __webpack_public_path__ + "img/app-gallery.85bff6a6.png";